"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBaseDomain = void 0;
// A targeted list of internally supported ccSLDs
// to avoid fetching a large public suffix list
var secondLevelDomains = [
    'co.uk',
    'co.jp',
    'com.au'
];
// Regex to match the domain and optional TLDs, ignoring protocol and subdomains
var pattern = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n?]+)/;
/**
 * Parse base domain from url with protocols, subdomains, ports, and multi-part TLDs
 * @param {string} url - URL to parse
 * @returns {string} baseDomain
 * @description Parses the base domain from a url
 * @example parseBaseDomain('www.godaddy.com') => 'godaddy.com'
 * @example parseBaseDomain('https://ae.dev-godaddy.com/ar') => 'dev-godaddy.com'
 * @example parseBaseDomain('https://local.gasket.dev-godaddy.com') => 'dev-godaddy.com'
 * @example parseBaseDomain('https://www.123reg.co.uk') => '123reg.co.uk'
 */
function parseBaseDomain(url) {
    var match = url === null || url === void 0 ? void 0 : url.match(pattern);
    if (match) {
        var parts = match[1].split('.');
        var lastTwoParts = parts.slice(-2).join('.');
        // By default, slice the last two parts
        var sliceStart = -2;
        if (secondLevelDomains.includes(lastTwoParts)) {
            sliceStart = -3;
        }
        return parts.slice(sliceStart).join('.');
    }
    return null;
}
exports.parseBaseDomain = parseBaseDomain;
